<script>
import store from './store'
import config from './config'
import calcInput from 'apps/bankrate-calculators/components/number-input.vue'
import calculatorEventBus from 'apps/bankrate-calculators/events'
import { mapGetters, mapState } from 'vuex'

const template = store.state.isMobile
  ? require('./mobile-template.html')
  : require('./template.html')

export default {
  template,
  store,
  components: { calcInput },
  data() {
    return { config: config }
  },
  created() {
    this.$store.dispatch('loadConfig', config)
    this.$store.dispatch('calculate')
  },
  computed: {
    ...mapGetters(['pageHasErrors', 'dataChanged']),
    ...mapState(['isMobile', 'partialLTV', 'cumulativeLTV'])
  },
  methods: {
    calculate: function() {
      if (!this.dataChanged) {
        return
      }

      this.$store.dispatch('calculate')
      calculatorEventBus.$emit('calculator:calculation')
    }
  }
}
</script>
